// extracted by mini-css-extract-plugin
export default {"stack":"_2yyQl","space-small":"_3Ydvd","spaceSmall":"_3Ydvd","space-medium":"eifST","spaceMedium":"eifST","space-large":"_1Pxtu","spaceLarge":"_1Pxtu","column":"_1q2IZ"};